import { lazy } from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import { publicRoutes } from './public.routes';
import { adminRoutes } from './admin.routes';
import AuthLayout from '../layouts/AuthLayout';


const LoginPage = lazy(() => import('@/features/auth/pages/LoginPage'));


export const router = createBrowserRouter([
  // Auth Routes
  {
    path: '/auth',
    element: <AuthLayout />,
    children: [
      {
        path: 'login',
        element: <LoginPage />,
      },
      // {
      //   path: 'register',
      //   element: <RegisterPage />,
      // },
      // {
      //   path: 'forgot-password',
      //   element: <ForgotPasswordPage />,
      // },
      // {
      //   path: 'reset-password/:token',
      //   element: <ResetPasswordPage />,
      // },
    ],
  },
  ...publicRoutes,
  ...adminRoutes,
  {
    path: '*',
    element: (<>
        Not Found
      </>),
  }
]);